import { FC } from 'react';

import { SelectForm, SelectFormProps } from './SelectForm';

const monthTurnoverOptions: { value: string | ''; name?: string }[] = [
  { value: '0 - 100 000' },
  { value: '100 000 - 500 000' },
  { value: '500 000 - 1 500 000' },
  { value: '> 1 500 000' },
];

type MonthTurnoverSelectFormProps = Omit<SelectFormProps<string>, 'options'>;

export const MonthTurnoverSelectForm: FC<MonthTurnoverSelectFormProps> = (props) => {
  return <SelectForm {...props} options={monthTurnoverOptions} />;
};
